import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";


const RewardListItem = (props) => {
    var rewardItemClass = "reward-card-active"
    if(props.rewardLevel !== props.reward.award_level){
        rewardItemClass = "reward-card-inactive"
    }

    var rewardRibbonClass = "ribbon"
    if(props.reward.award_level == "gold"){
        rewardRibbonClass = "ribbon"
    }else if(props.reward.award_level == "silver"){
        rewardRibbonClass = "ribbon-gray"
    }

    var style={ backgroundImage: "url("+props.reward.image_bg.url+")"};

    // if (reward.award_level == this.state.data.award_level){
    //     var rewardDivClass = "reward-active"
    
    // <div className="h1">congrats</div>
    
    
    // }
    // else { 
    //     <div className="h1">congrats</div>

    //  };

    // use this in the render markup:
    // <div className='${rewardDivClass}'> 


    // style={{ backgroundImage: "url(" + {reward.image_bg.url} + ")"}}

    // {unreadMessages.length > 0 &&
    //     <h2>
    //       You have {unreadMessages.length} unread messages.
    //     </h2>
    //   }
      
    return(
    <div className="reward-container-ribbon">
        <div className={rewardRibbonClass}><span>{props.reward.award_level}</span></div>
    <Link to={ "/reward/" + props.reward.id }>
    {/* need to add background image url inline to reward-card remember to delete from app.css */}
        <div className={rewardItemClass} style={style}>
            <div className="reward-card-text-wrapper">
                <div className="reward-card-text-bg">
                    <span className="reward-card-h1">{props.reward.title}</span>
                </div>

                <div className="reward-card-text-bg">
                    <span className="reward-card-h2">{props.reward.description}</span>
                </div>
            </div>
            <div className="discount-card-terms-bar">
                <div className="redemptions-count">2 Redemptions Available</div>
                <div className="expiration-date">Expires June 1</div>
            </div>
        </div>
    </Link> 
    </div>
    )
}

export default RewardListItem;


// WEBPACK FOOTER //
// ./src/components/RewardListItem/RewardListItem.js